import { Checkbox, FormControlLabel } from '@mui/material'
import jwtDecode from 'jwt-decode'
import { IAuthJWT } from '../../config/axios'
import colors from '../../constants/colors'
import questionsService from '../../services/questionsService'
import { userRoles } from '../../store/auth/userTypes'
import { ICaseTypeDTO } from '../../store/reports/types'
import { IFilterObject } from '../FilterComponent'
import constants from './constants'

import { info } from '../../utils/alertUtils';

const renderCheckboxes = (items: IFilterObject[], onChange: any, section: string) => {
  return items.map((item, index) => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            value={item?.value}
            sx={{ color: colors.BLACK, '&.Mui-checked': { color: colors.BLACK } }}
            onChange={e => {
              onChange(e, constants.sectionNames[section])
            }}
            checked={item?.checked}
            id={item?.title}
          />
        }
        label={item?.title}
        key={`${item?.value}-${index}`}
      />
    )
  })
}

const getSelectedValues = (filters: IFilterObject[]) => {
  const selectedValues: { [key: string]: string } = {}

  filters.forEach(filter => {
    if (filter.section) {
      const checkedInSection = filter.subTypes
        ?.filter(subType => subType.checked)
        .map(type => type.value)
        .join()

      if (checkedInSection?.length) {
        selectedValues[filter.value] = checkedInSection
      }
    }
  })

  return selectedValues
}

//check first if casetype is checked
//don't navigate if it's OSHA or not checked
//but if user is admin navigate for not checked because he can see archived
const isQuestionVisible = async (
  questionId: number,
  selectedReportTypes: ICaseTypeDTO[] | undefined,
  navigate: any,
) => {
  const { data: questionType } = await questionsService.getQuestionCaseType(questionId)
  if (questionType?.category === 'OSHA') {
    navigate(`/cases/overview#${questionId}`)
    return
  }
  const tokenData: IAuthJWT = jwtDecode(localStorage.getItem('accessToken') || '')
  const isUserAdmin = tokenData?.roles.find(role => role === userRoles?.ADMIN)
  if (isUserAdmin) {
    navigate(`/cases/investigation#${questionId}`)
    return
  }
  if (selectedReportTypes?.find(type => type?.text === questionType?.category)) {
    navigate(`/cases/investigation#${questionId}`)
  }

  info('This question has been archived and is viewable by Admin users only.')
  return
}

export default {
  renderCheckboxes,
  getSelectedValues,
  isQuestionVisible,
}
